import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M.003 16h31.994v.016c.032 2.456-.193 5.233-.834 7.984H.836c-.67-2.744-.864-5.516-.833-8",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M.835 24h30.327l-.029.124s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M31.997 16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.662 2.752.862 5.57.83 8.091",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "m24 11-1.69 2.757.068-3.233-2.913 1.405 1.806-2.683-3.21-.392 2.97-1.28-2.489-2.066 3.19.527-.976-3.083 2.399 2.17L24 2l.845 3.122 2.399-2.17-.977 3.083 3.19-.527-2.488 2.065 2.97 1.28-3.21.393 1.806 2.683-2.913-1.405.068 3.233z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M24 10.667a2.667 2.667 0 1 0 0-5.334 2.667 2.667 0 0 0 0 5.334c-1.473 0 0 0 0 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M24 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4c-1.105 0 0 0 0 0",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagRwa = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagRwa_default = SvgFlagRwa;

export { FlagRwa_default as default };
